import { createReducer, on } from '@ngrx/store';
import { initialGroupsArticlesState, IGroupsArticlesState } from './groupsArticles.state';
import {  AddGroupArticlesError, AddGroupArticlesSuccess, DeleteGroupArticlesError, DeleteGroupArticlesSuccess, GroupsArticlesByGestiuneIdLoaded, GroupsArticlesLoaded, UpdateGroupArticlesError, UpdateGroupArticlesSuccess } from './groupsArticles.actions';

export const initialState: IGroupsArticlesState = {
  groupsArticles: [],
  groupsArticlesByGestiune: {},
};

const setGroupsArticles = (state: IGroupsArticlesState, { groupsArticles }: { groupsArticles: any[] }) => ({
  ...state,
  groupsArticles: groupsArticles 
});

const _groupsArticlesReducer = createReducer<IGroupsArticlesState>(
  initialGroupsArticlesState,
  on(GroupsArticlesLoaded, setGroupsArticles),
  on(AddGroupArticlesSuccess, (state, { groupsArticles }) => ({
    ...state,
    groupsArticles: [...state.groupsArticles, groupsArticles],
    
  })),
  on(UpdateGroupArticlesSuccess, (state, { groupsArticles }) => ({
    ...state,
    groupsArticles: state.groupsArticles.map(group =>
      group.id === groupsArticles.id ? groupsArticles : group
    ),
    
  })),
  on(DeleteGroupArticlesSuccess, (state, { id }) => ({
    ...state,
    groupsArticles: state.groupsArticles.filter(group => group.id !== id),

  })),

  on(GroupsArticlesByGestiuneIdLoaded, (state, { gestiuneId, groupsArticles }) => ({
    ...state,
    groupsArticlesByGestiune: {
      ...state.groupsArticlesByGestiune,
      [String(gestiuneId ?? 'null')]: groupsArticles,
    },
  })),

);

export function groupsArticlesReducer(state: IGroupsArticlesState, action): IGroupsArticlesState {
  return _groupsArticlesReducer(state, action);
}
